<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      maxHeight: 'auto',
    };
  },
  computed: {
    style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
        maxHeight: this.maxHeight,
        overflowY: this.maxHeight === 'auto' ? 'visible' : 'auto',
      };
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$nextTick(() => {
      this.$el.focus();
      this.adjustPosition();
    });
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    adjustPosition() {
      const { height, width } = this.$el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      const buffer = 16;

      let newLeft = Math.min(this.x, innerWidth - width - buffer);
      newLeft = Math.max(buffer, newLeft);

      let newTop = this.y;

      if (newTop + height > innerHeight) {
        if (newTop - height > buffer) {
          newTop -= height;
        } else {
          const spaceBelow = innerHeight - newTop - buffer;
          const spaceAbove = newTop - buffer;

          if (spaceBelow >= spaceAbove) {
            this.maxHeight = `${spaceBelow}px`;
          } else {
            newTop = buffer;
            this.maxHeight = `${spaceAbove}px`;
          }
        }
      }

      this.top = newTop;
      this.left = newLeft;
    },
  },
};
</script>

<template>
  <div
    class="fixed outline-none z-[9999] cursor-pointer"
    :style="style"
    tabindex="0"
    @blur="$emit('close')"
  >
    <slot />
  </div>
</template>
